
const entdata = {
  types: [
    {
      name: "不限",
      value: "不限"
    },
    {
      name: "有限公司",
      value: "有限责任公司"
    },
    {
      name: "股份公司",
      value: "股份有限公司"
    },
    {
      name: "合伙企业",
      value: "合伙企业"
    },
    {
      name: "集体企业",
      value: "集体企业"
    },
    {
      name: "个人",
      value: "个人"
    },
    {
      name: "其它",
      value: "其它"
    }
  ],
  status: [
    {
      name: "不限",
      value: "不限"
    },
    {
      name: "开业",
      value: "在营（开业）企业"
    },
    {
      name: "注销",
      value: "注销"
    },
    {
      name: "吊销",
      value: "吊销"
    },
    {
      name: "迁出",
      value: "迁出"
    },
    {
      name: "撤销",
      value: "撤销"
    },
    {
      name: "其它",
      value: "其它"
    }
  ],
  reg: [
    {
      name: "不限",
      value: "不限"
    },
    {
      name: "10万以下",
      value: "0|10"
    },
    {
      name: "10-50万",
      value: "10|50"
    },
    {
      name: "50-100万",
      value: "50|100"
    },
    {
      name: "100-500万",
      value: "100|500"
    },
    {
      name: "500万-1000万",
      value: "500|1000"
    },
    {
      name: "1000万-5000万",
      value: "1000|5000"
    },
    {
      name: "5000万-1亿",
      value: "5000|10000"
    },
    {
      name: "1亿以上",
      value: "10000"
    }
  ],
  time: [
    {
      name: "不限",
      value: "不限"
    },
    {
      name: "3个月内",
      value: "0|0.25"
    },
    {
      name: "1年内",
      value: "0|1"
    },
    {
      name: "1-5年",
      value: "1|5"
    },
    {
      name: "5-10年",
      value: "5|10"
    },
    {
      name: "10-15年",
      value: "10|15"
    },
    {
      name: "15年以上",
      value: "15"
    }
  ],
  contact: [
    {
      name: "不限",
      value: "不限"
    },
    {
      name: "有联系方式",
      value: "contact"
    },
    {
      name: "有手机",
      value: "mobile"
    },
    {
      name: "有固话",
      value: "phone"
    },
    {
      name: "有邮箱",
      value: "email"
    },
    {
      name: "有QQ",
      value: "qq"
    },
    {
      name: "有网址",
      value: "website"
    }
  ]
}

export default entdata
